module.exports = __webpack_public_path__ + "img/lcl-consol-1.b358cea4.png";